import React from 'react';
import {CSSTransitionGroup} from 'react-transition-group';
import Waypoint from 'react-waypoint';

export default class ImageWithTransition extends React.Component {
    constructor(props) {
        super(props);
        this.state = {showedImage: false};
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({firstImageShowing: true});
        },
        1500);
    }

    render() {
        return (
            <div style={{display: 'inline-block', position: 'relative'}}>
                <img
                    className="img-responsive"
                    src={this.props.images[0]} />
                <Waypoint
                    scrollableAncestor={typeof window !== 'undefined' && window}
                    onEnter={() => { this.setState({showedImage: true}); }}
                    onLeave={() => { this.setState({showedImage: false}); }}
                />
                { this.state.showedImage &&
                    <span>
                        <CSSTransitionGroup
                            transitionName="secondImage"
                            transitionAppearTimeout={1500}
                            transitionAppear={true}
                            transitionEnter={false}
                            transitionLeave={false}
                        >
                            <img
                                className="img-responsive"
                                style={{position: 'absolute', top: 0}}
                                src={this.props.images[1]} />
                        </CSSTransitionGroup>
                        {this.props.images.length === 3 && this.state.firstImageShowing &&
                        <CSSTransitionGroup
                            transitionName="thirdImage"
                            transitionAppearTimeout={1500}
                            transitionAppear={true}
                            transitionEnter={false}
                            transitionLeave={false}>
                            <img
                                className="img-responsive"
                                style={{position: 'absolute', top: 0}}
                                src={this.props.images[2]} />
                        </CSSTransitionGroup>
                        }
                    </span>
                }
            </div>
        );
    }
}
